@let b = balance$ | async;

@if (variant === 'compact') {
  @if (b) {
    <div class="balance-chip" [class]="'tone-' + view(b).tone" [matTooltip]="advice(b)">
      <mat-icon>{{ view(b).icon }}</mat-icon>
      <span class="chip-counts tabular">Orders {{ b.activeOrders }} · Target {{ b.targetOrders }}</span>
      <span class="chip-label">{{ view(b).label }}</span>
    </div>
  }
} @else {
  <section class="balance-panel" [class]="b ? 'tone-' + view(b).tone : ''" aria-label="Orders vs. buy contracts">
    <header class="panel-row">
      <mat-icon class="panel-icon" matTooltip="Orders vs. buy contracts">balance</mat-icon>
      @if (b) {
        <span class="state-pill">
          <mat-icon>{{ view(b).icon }}</mat-icon>
          {{ pillLabel(b) }}
        </span>
        <span class="summary tabular">
          {{ b.activeOrders }} open · target {{ b.targetOrders }}
          <span class="muted">({{ b.activeBuyContracts }} × {{ formatRatioNumber(b.targetRatio) }})</span>
        </span>
      } @else {
        <span class="summary muted">Loading balance…</span>
      }
      <span class="spacer"></span>
      @if (b) {
        <button mat-button class="details-btn" (click)="toggleDetails()" [attr.aria-expanded]="detailsOpen"
          aria-controls="balance-details">
          Details
          <mat-icon iconPositionEnd>{{ detailsOpen ? 'expand_less' : 'expand_more' }}</mat-icon>
        </button>
      }
      <button mat-icon-button (click)="refresh()" matTooltip="Refresh" aria-label="Refresh balance">
        <mat-icon>refresh</mat-icon>
      </button>
    </header>

    @if (b) {
      <div class="meter" [class.meter--empty]="!b.activeOrders && !b.targetOrders"
        [matTooltip]="b.activeOrders + ' open orders vs. target ' + b.targetOrders">
        <div class="meter-fill" [style.width.%]="fillShare(b)"></div>
        <div class="meter-mark"></div>
      </div>

      @if (detailsOpen) {
        <div id="balance-details" class="details">
          <div class="sides">
            <div class="side">
              <div class="side-label">Open orders</div>
              <div class="side-value tabular">{{ b.activeOrders }}</div>
              <div class="side-sub tabular">
                {{ b.pendingOrders }} pending · {{ b.transferringOrders }} transferring
                @if (b.stoppedOrders) {
                  · {{ b.stoppedOrders }} stopped (not counted)
                }
              </div>
            </div>

            <div class="side">
              <div class="side-label">Ratio</div>
              <div class="side-value tabular">
                {{ b.currentRatio === null ? '—' : formatRatio(b.currentRatio) }}
                <span class="unit">now · target {{ formatRatio(b.targetRatio) }}</span>
              </div>
              <div class="side-sub">Target ratio is set in Settings</div>
            </div>

            <div class="side side--end">
              <div class="side-label">Auto-buy</div>
              <div class="side-value tabular">{{ b.readyStocks }} <span class="unit">ready stocks</span></div>
              <button type="button" class="auto-state" [class.on]="b.autoBuy.is_active" (click)="openAutoBuy()"
                matTooltip="Configure auto-buy">
                <span class="dot"></span>
                @if (b.autoBuy.is_active) {
                  Auto-buy on · {{ b.autoBuy.active_leases }}/{{ b.autoBuy.desired_stocks }} buying
                } @else {
                  Auto-buy off — stocks are not used
                }
                <mat-icon>settings</mat-icon>
              </button>
            </div>
          </div>

          <p class="advice">{{ advice(b) }}</p>
          <p class="updated muted">Updated {{ b.updatedAt | date: 'HH:mm:ss' }}</p>
        </div>
      }
    }
  </section>
}
